import { HStack, Text } from "@chakra-ui/react"
import Dialog from "@hydrologiq/shared/chakra/Dialog"
import { ActionButton } from "@hydrologiq/shared/content/components/Button"

interface DeleteConfirmDialogProps {
  open: boolean
  connectorName: string
  onConfirm: () => void
  onClose: () => void
  loading?: boolean
  /** What is being deleted, for the title and button description. Defaults to "connector". */
  noun?: string
}

/**
 * DeleteConfirmDialog - Confirmation dialog shown before deleting a data connector.
 *
 * Prompts the user with "Are you sure you want to delete this <name>? This is irreversible."
 * Provides Cancel and Delete buttons.
 */
export function DeleteConfirmDialog({
  open,
  connectorName,
  onConfirm,
  onClose,
  loading = false,
  noun = "connector",
}: DeleteConfirmDialogProps) {
  return (
    <Dialog
      title={`Delete ${noun}`}
      open={open}
      setOpen={(isOpen) => {
        if (!isOpen) onClose()
      }}
      onClose={onClose}
      footer={
        <HStack gap={3}>
          <ActionButton
            onClick={onClose}
            disabled={loading}
            context={{
              label: "Cancel",
              description: "Cancel deletion",
              variant: "secondary",
            }}
          />
          <ActionButton
            onClick={onConfirm}
            disabled={loading}
            context={{
              label: "Delete",
              description: `Permanently delete this ${noun}`,
              variant: "warning",
            }}
          />
        </HStack>
      }
    >
      <Text>
        Are you sure you want to delete <strong>{connectorName}</strong>? This is irreversible.
      </Text>
    </Dialog>
  )
}

export default DeleteConfirmDialog
